export const {
    REACT_APP_THEME,
    REACT_APP_API_URL,
    REACT_APP_WS_URL,
    REACT_APP_IOKA_WIDGET_LIB,
    REACT_APP_LIQPAY_WIDGET_LIB,
} = process.env;
